import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Input, Select, Space, Spin } from "antd";
import { Collapse } from "antd";
import ExelDownload from "../image/exeldownload.svg";
import { getRequest } from "../axios";
import { ErrorNotificationMsg } from "../utils/Notifications";
import { authUserData } from "../utils/Helper";
import AssignedSiteEmployeeGrid from "../feature/PR/AssignedSiteEmployeeGrid";
import NewPrDetails from "../feature/PR/NewPrDetails";
import ButtonField from "../common/htmlComponents/ButtonField";
import ApprovalForPR from "./ApprovalForPR";
import EmailPRApprovalRejectWithReason from "./EmailPRApprovalRejectWithReason";

const { Option } = Select;

const handleChange = (value) => { };

const { Panel } = Collapse;

const EmailPRApprovalNew = () => {
  const { t } = useTranslation();
  const { id, prType, resetToken } = useParams();
  const navigate = useNavigate();
  const [material, setMaterial] = useState(null);

  const CompanyID = authUserData()?.company ? authUserData()?.company : null;

  const [purchaseRequisitionDetails, setPurchaseRequisitionDetails] = useState(
    []
  );
  const [loading, setLoading] = useState(false);
  const [prNum, setPrNum] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const action = queryParams.get('action');

  if (action === 'Approve') 
    {
      return <ApprovalForPR resetToken={resetToken} id={id} prType={prType} />;
    } else if(action === "RejectWithReason"){
      return <EmailPRApprovalRejectWithReason resetToken={resetToken} id={id} prType={prType} />;
    } else {
        return <div>Invalid action or no action specified</div>;
      }

      
  const handleExcelDownload = async () => {

    const endpoint = `purchase-requisition/${id}/download-single-pr-history-excel/`;
    const fileType = "csv";

    try {
      //setBtnloading(true);
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
   
          link.download = `purchase_requisition_${CompanyID}-${+new Date()}.${fileType}`;
          link.click();
          //setBtnloading(false);
        })
        .catch((error) => {
          ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      ErrorNotificationMsg(error);
    }
  };



  const data = [];
  for (let i = 0; i < 3; ++i) {
    data.push({
      key: i.toString(),
      name: "Screen",
      platform: "iOS",
      version: "10.3.4.5654",
      upgradeNum: 500,
      creator: "Jack",
      createdAt: "2014-12-24 23:12:00",
    });
  }


  const handleDownloadPDF = async () => {
    try {
      const endpoint = `purchase-requisition/${id}/download-pr-history-pdf/`;
      const response = await getRequest(endpoint, { responseType: "blob" }); // Specify responseType as 'blob' to handle binary data (PDF)
      const blob = new Blob([response.data], {
        type: "application/pdf", // Set MIME type to application/pdf for PDF file
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `purchase_requisition_${id}-${+new Date()}.pdf`; // Set file extension to .pdf
      link.click();
    } catch (error) {
      ErrorNotificationMsg("Error downloading PR");
    }
  };
  const expandedRowRender = (materialTypeName, index) => {
    const columns = [
      {
        title: "sr No.",
        dataIndex: "srNo",
        key: "srNo",
        render: (text, record, index) => index + 1,
      },
      {
        title: "PO NUMBER",
        dataIndex: "PONUMBER",
        key: "PONUMBER",
      },
      {
        title: "Po date",
        dataIndex: "Podate",
        key: "Podate",
      },
      {
        title: "Vendor",
        dataIndex: "Vendor",
        key: "Vendor",
      },
      {
        title: "delivery status",
        dataIndex: "deliverystatus",
        key: "deliverystatus",
      },
      {
        title: "QTY",
        dataIndex: "QTY",
        key: "QTY",
      },
      {
        title: "Action",
        dataIndex: "operation",
        key: "operation",
        render: () => (
          <Space size="middle">
            <Select
              defaultValue="MT"
              style={{ width: 120 }}
              onChange={handleChange}
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
                { value: "Yiminghe", label: "yiminghe" },
              ]}
            />
          </Space>
        ),
      },
    ];
    const data = [];
    for (let i = 0; i < 3; ++i) {
      data.push({
        key: i.toString(),
        srNo: "1",
        PONUMBER: "00001",
        Podate: "24-08-23 09:05",
        Vendor: "Vendor 1",
        deliverystatus: "Partially",
        QTY: "25",
      });
    }
    return (
      <Table
        className="subtbl"
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={loading}
      />
    );
  };
 
  const renderTables = () => {
    if (!purchaseRequisitionDetails.purchase_requisition_details) return null;

    const groupedDetails = {};
    purchaseRequisitionDetails.purchase_requisition_details.forEach(
      (detail) => {
        const subCategory = detail.sub_category;
        if (!groupedDetails[subCategory]) {
          groupedDetails[subCategory] = { sites: {}, details: [] };
        }
        groupedDetails[subCategory].details.push(detail);
        detail.site_wise.forEach((site) => {
          groupedDetails[subCategory].sites[site.site_name] = true;
        });
      }
    );

    return Object.entries(groupedDetails).map(
      ([subCategory, { sites, details }], index) => {

        const siteNames = Object.keys(sites);
        const site_wise = Object.keys(sites);
        const data = [];
   
        details.map((detail, index) =>
          data.push({
            ...detail,
            srNo: index,
            key: detail.pr_details_id.toString(),
            totalQuantity: `${detail.total_quantity} ${detail.unit_of_measurement_name}`,
          })
        );

        const siteNameColumns = siteNames.map((site, index) => ({
          title: site,
          dataIndex: index,
          key: index,
          width: 170,
        }));

        const siteWiseColumns = site_wise.map((site, siteIndex) => ({
          title: "Site Input",
          dataIndex: `siteInput_${siteIndex}`,
          key: `siteInput_${siteIndex}`,
          render: (text, record) => {
            const matchingSite = record.site_wise.find(
              (s) => s.site_name === site
            );
            if (matchingSite) {
              return (
       
                <div className="lblvalue" style={{marginLeft: '5px'}}>
                  {matchingSite?.quantity}
                </div>
              );
            }
            return null; // If no matching site found, render nothing
          },
          width: 170,
        }));

        const columns1 = [
          {
            title: `${index + 1}`,
            dataIndex: "srNo", 
            key: "1",
            width: 50,
            render: (text, record, ind) => `${index + 1}.${ind + 1}`,
          },

          {
            title: `${subCategory}`,
            dataIndex: `${subCategory}`,
            key: `${subCategory}`,
            // width: 170,
            render: (text, record) => {
              console.log("record 1 ", record);
              return (
                <>
                  {record.site_wise.map((site, siteIndex) => (
                    <Input
                      readOnly
                      key={siteIndex}
                      style={{ width: "150px" }}
                      value={site.quantity}
                    />
                  ))}
                </>
              )
            },
          },

          ...siteNameColumns,
    
          {
            title: "TOTAL QTY.",
            dataIndex: "TOTAL",
            key: "8",
            width: 180,
          },
          {
            title: "UoM.",
            dataIndex: "UOM",
            key: "7",
            width: 160,
          },
        ];

        const thead = <Table columns={columns1} />;

        return (
 
          <Panel key={index.toString()} header={thead}>
            <Table
              columns={[
                {
                  title: `${index + 1}`,
                  dataIndex: "srNo", 
                  key: "1",
                  width: 50,
                  render: (text, record, ind) => `${index + 1}.${ind + 1}`,
                },
                {
                  title: "Type Name",
                  dataIndex: "material_type_name_by_company",
                  key: "material_type_name_by_company",
                  // width: 470,
                },
                ...siteWiseColumns,             
                {
                  title: "Total Quantity",
                  dataIndex: "totalQuantity",
                  key: "totalQuantity",
                  width: 180,
                  render: (text, record) => (
                    <div className="lblvalue" style={{marginLeft: '5px'}}>
                      {record.total_quantity}
                    </div>
                  ),
                },
                {
                  title: "UOM",
                  dataIndex: "unit_of_measurement",
                  key: "unit_of_measurement",
                  width: 160,
                  render: (text, record) => {
                    return (
                    <div className="lblvalue" style={{marginLeft: '5px'}}>
                      {record.unit_of_measurement_name}
                    </div>
                    )
                  },
                },
              ]}
              dataSource={data}
              pagination={false}
            />
          </Panel>
        );
      }
    );
  };

  return (
    <>
      <Spin spinning={loading}>
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              <h3>Purchase Requisition (PR) - Details</h3>

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to="/purchase-requisition-history">
                    Purchase Requisition History
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Purchase Requisition Details</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
        </div>
        {/* <section className="grid-sec mt-5">
          <div className="PR-body">
            <div className="filterrow">
              <div className="filtercol">
                <Space wrap>
                  <div className="lblwrp">
                    <label>PR Number</label>
                    <h6> {purchaseRequisitionDetails.pr_number}</h6>
                  </div>
                  <div className="lblwrp">
                    <label>PR Created Date</label>
                    <h6>{purchaseRequisitionDetails.pr_created_date}</h6>
                  </div>
             
                  <div className="lblwrp">
                    <label>PO Order Placed</label>
                    <h6>{purchaseRequisitionDetails.po_order_placed}</h6>
                  </div>
                  <div className="lblwrp">
                
                  </div>
                </Space>
              </div>
              <div className="btnscol">
                <Space>
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Excel"
                    label="Excel"
                    onClick={handleExcelDownload}
                    icon={<img src={ExelDownload} alt="Plus Square" />}
                  />
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="PDF"
                    label="View PDF"
                    onClick={() => navigate(`/purchase-requisition/details/pdf/${id}`)}

                  />
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="PDF"
                    label="PDF"
                    onClick={handleDownloadPDF}
                    icon={<img src={ExelDownload} alt="Plus Square" />}
                  />
                </Space>
              </div>
            </div>


            <Collapse defaultActiveKey={["0"]}>{material === "City Wise" ? <NewPrDetails PRid={id} /> : renderTables()}</Collapse>

            <div className="btnwrp">
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="Back"
                label="Back"
                onClick={() => navigate("/purchase-requisition-history")}
              />
            </div>
          </div>
        </section> */}
      </Spin>
    </>
  );
};
export default EmailPRApprovalNew;
